import { render, staticRenderFns } from "./nfdtDetail.vue?vue&type=template&id=45675787&scoped=true&"
import script from "./nfdtDetail.vue?vue&type=script&lang=js&"
export * from "./nfdtDetail.vue?vue&type=script&lang=js&"
import style0 from "./nfdtDetail.vue?vue&type=style&index=0&id=45675787&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45675787",
  null
  
)

export default component.exports